<template>
  <div class="pay">
    <div class="top"></div>
    <div class="detail">
      <img :src="packages.img" alt="">
      <div class="info">
        <h5>{{packages.name}}</h5>
        <div class="price">￥<b>{{packages.price}}</b><del>原价￥{{packages.yprice}}</del></div>
      </div>
    </div>
    <div class="payBox">
      <div class="payTitle">选择支付方式</div>
      <van-cell-group>
        <van-cell center v-if="isWechat()">
          <template #title>
            <van-icon name="wechat-pay"  color="#3DB034" size="1.5rem" />
            <span class="custom-title">微信</span>
          </template>
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template #right-icon>
            <van-icon name="checked" size='1rem' :color="payWay === 'wxpay'?'#3DB034':'#DCDDDE'" class="search-icon" @click="payWay='wxpay'"/>
          </template>
        </van-cell>
        <van-cell center v-else>
          <template #title>
            <van-icon name="alipay"  color="#06B4FD" size="1.5rem" />
            <span class="custom-title">支付宝</span>
          </template>
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template #right-icon>
            <van-icon name="checked" size='1rem' :color="payWay === 'alipay'?'#06B4FD':'#DCDDDE'" class="search-icon" @click="payWay='alipay'"/>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="payFor">
      <div>合计：<span>￥{{order.amount}}</span></div>
      <div class="sure" @click="goPay()">确认支付</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: null,// 套餐id
      order_id: '',// 订单编号
      saler_id: '',
      agent_id: '',
      payWay: 'wxpay',// 默认微信支付
      payStatus: true,// 支付状态
      packages: '',// 套餐包详情
      order: '',// 订单详情
      csrf_token: '',// post附加
      paying: '',// 支付状态
      timeTotal: 0,// 计时总时长
      toast: null,// 查询支付时展示
      phone: '',// 帐号
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.order_id = this.$route.query.order_id;
    this.saler_id = this.$route.query.saler_id || '';
    this.agent_id = this.$route.query.agent_id || '';
    this.phone = this.$route.query.phone;
    this.payWay = this.isWechat() ? 'wxpay' : 'alipay';
    this.getDetail()
    // 是否已支付跳转回来
    if(this.$route.query.payStatus == 1){
      // 打开轮询
      this.setTime();
    }
  },
  methods: {
    // 获取套餐详情
    async getDetail() {
      const {data: res} = await this.$get('buy/order_info',{order_id: this.order_id, token: localStorage.getItem('CJKT_TOKEN')})
      this.packages = res.packages[0]
      this.order = res.order
    },
    // 获取 csrf_token
    async getCsrf_token(){
      let url = "token/csrf"
      const {data: res} = await this.$get(url)
      this.csrf_token = res.csrf_token;
    },
    // 获取支付商户
    async merchants() {
      const {data: res} = await this.$get('package/merchant',{agent_id: this.agent_id, payport: this.payWay})
      this.merchant = res.merchant;
    },
    // 去支付
    async goPay() {
      this.$Toast({
        duration: 0,
        type: 'loading',
        message: '加载中'
      })
      await this.merchants()
      await this.getCsrf_token()
      let params = {
        order_id: this.order_id,
        csrf_token: this.csrf_token,
        is_coin: 0,
        token: localStorage.getItem('CJKT_TOKEN')
      }
      if(this.order.amount === 0) {
        params.is_coin = 1
      }
      const res = await this.$post('buy/affirm_pay', params)
      this.$Toast.clear()
      //! 订单金额为 0时 
      if(params.is_coin){
        if(res.code == 0){
          this.$Toast.success('购买成功')
          // 成功回调
          this.successCb()
        }else{
          this.$Toast.fail(res.msg)
        }
      }else{
        //! 微信 支付宝 购买
        if(res.code == 50001){
          window.location.href = `http://api.cjkt.com/pay/${this.merchant}?token=${localStorage.getItem('CJKT_TOKEN')}&orderid=${this.order_id}&type=order&payport=${this.payWay}&device=wap&trade_type=JSAPI&redirect_uri=${encodeURIComponent(location.href + '&payStatus=1')}&cancel_redirect_uri=${encodeURIComponent(location.href + '&payStatus=0')}`
        }else if(res.code == 0){
          this.$Toast.success('购买成功')
          this.successCb();
        }else{
          this.$Toast.fail(res.msg)
        }
      }
    },
    // 支付完成后查询支付结果
    async checkPaymentDone() {
      const params = {
        token: localStorage.getItem('CJKT_TOKEN'),
        orderid: this.order_id,
        type: "order",
      };
      const res = await this.$get("/pay/checkPayStatus", params);
      if (res.code == 0) {
        this.paying = res.data;
      }
    },
    // 设置轮询
    setTime() {
      this.toast = this.$Toast.loading({
        duration: 0,
        message: '查询支付中'
      })
      const that = this;
      that.timeTotal = 0;
      let timeId = setInterval(async () => {
        await that.checkPaymentDone();
        that.timeTotal ++;
        if (that.paying == 1) {
          clearInterval(timeId);
          that.toast = that.$Toast.clear();
          that.successCb()
        }
        if (that.timeTotal == 30) {
          this.$Toast.fail('交易超时');
          clearInterval(timeId);
        }
      }, 2000);
    },
    // 一.成功支付的回调
    successCb() {
      this.$router.push({ path: 'daySuccess', query: { phone: this.phone, new: true } })
    },
    // 二.未成功支付的回调
    failCb() {
      this.$Toast('交易超时\n支付失败')
    },
    // 是否为微信浏览器
    isWechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    }
  },
}
</script>

<style scoped lang='scss'>
@mixin ellipsis {
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.pay{
  background: #F1F5F8;
  min-height: 100vh;
  text-align: center;
  .top{
    width: 100%;
    height: .5rem;
  }
  .detail{
    width: 100%;
    height: 4.9rem;
    background: #fff;
    padding: .6rem .8rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: .5rem;
    >img{
      width: 5.65rem;
      height: 3.7rem;
      border-radius: .3rem;
      margin-right: .8rem;
    }
    .info{
      height: 3.7rem;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      h5{
        margin: 0;
        max-width: 10.2rem;
        font-size: .82rem;
        font-weight: 600;
        color: #333;
        @include ellipsis;
      }
      .price{
        color: #FF293E;
        font-size: .6rem;
        b{
          font-size: 1.15rem;
          font-weight: 500;
        }
        del{
          color: #999;
          margin-left: .3rem;
        }
      }
    }
  }
  .payBox{
    height: 2.4rem;
    background-color: #fff;
    .payTitle {
      color: #999;
      text-align: left;
      font-size: .7rem;
      padding: .75rem .8rem .5rem;
    }
    .van-cell__title, .van-cell__value{
      flex: none;
      margin-right: auto;
      display: flex;
      align-items: center;
    }
    .custom-title {
      margin-left: .7rem;
      vertical-align: middle;
      font-size: .7rem;
      color: #333;
    }
    .search-icon {
      font-size: 16px;
      line-height: inherit;
    }
  }
  .payFor{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 18.75rem;
    height: 3rem;
    background: #FFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .8rem;
    box-sizing: border-box;
    font-size: .8rem;
    font-size: 16px;
    span{
      color: #F6313F;
    }
    .sure{
      color: #fff;
      width: 6.7rem;
      height: 2.25rem;
      line-height: 2.25rem;
      background: #F6313F;
      box-shadow: 0px .15rem .25rem 0px rgba(255,88,76,0.5);
      border-radius: 1.15rem;
    }
  }
}
</style>